/**************************************************
 * Nombre:       Tarjeta_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useContext} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {contexApp} from "../../App";

const Tarjeta_Categorias = ({item}) => {
    const {sCell} = useResponsive()
    const cData = useContext(contexApp)


    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                transition: 'all .2s ease-in-out',
                borderRadius: '7px',
                border: 1,
                borderColor: '#ffffff60',
                background: 'rgba(255, 255, 255, 0.32)',
                backdropFilter: 'blur(2px)',
                p: 2,
                color: '#fff',
                cursor: 'pointer',
                '&:hover': {
                    boxShadow: 10

                }
            }}
            spacing={1}
        >

            <Grid container size={{xs: 4, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.icono} width={sCell ? '100%' : '80%'} height={'auto'} alt={item.nombre}/>
            </Grid>

            <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 18, fontWeight: 600}}>{item.nombre}</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                        <Typography
                            sx={{fontSize: 12, fontWeight: 400}}>{`${cData.numTours[item.nombre]} Tours`}</Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Categorias    